var map = {
	"./Across.jpg": 72114,
	"./Anyswap.png": 55947,
	"./Anyswap.svg": 55152,
	"./Artwork.svg": 56287,
	"./Artwork_fxdx.svg": 44671,
	"./Banxa.png": 15194,
	"./Beamer.png": 61668,
	"./Bico.png": 42023,
	"./Celer.png": 79484,
	"./Connext.png": 97914,
	"./DROP_DOWN.svg": 18692,
	"./Group (3).svg": 81342,
	"./Hop.png": 79577,
	"./Hop.svg": 68415,
	"./Hop_Exchange.png": 49890,
	"./Hop_dark.png": 20815,
	"./Hop_dark.svg": 45106,
	"./Iconic_logo_White.svg": 39748,
	"./Launchv2img.svg": 68118,
	"./LayerSwap.png": 69949,
	"./Meson.png": 72455,
	"./NEW_Iconic_Logo.svg": 19153,
	"./NEW_LOGO_BLACK.svg": 38629,
	"./NEW_LOGO_LIGHT.svg": 35957,
	"./OP_Logo.png": 60917,
	"./Orbiter.jpg": 56896,
	"./Poly_Network.png": 55771,
	"./Stargate.png": 32203,
	"./Symbiosis.jpg": 91797,
	"./Synapse.png": 3935,
	"./Synapse.svg": 73391,
	"./XY_Finance.png": 9615,
	"./airdrop.svg": 66787,
	"./binance.png": 66030,
	"./bscscan.png": 81128,
	"./btn_big_arbitrum.png": 70756,
	"./btn_big_avalanche.png": 11784,
	"./btn_big_bsc.png": 74872,
	"./btn_big_purchasegmx.png": 43760,
	"./btn_big_purchasegmx.svg": 12346,
	"./bungee.png": 74878,
	"./buy_fxdx.svg": 34636,
	"./buy_fxdx_bond.svg": 77913,
	"./buy_transfer_eth.svg": 66961,
	"./celercB.jpeg": 23389,
	"./chainPort.svg": 87816,
	"./chat.svg": 91304,
	"./coinbaseWallet.png": 32346,
	"./coingecko.png": 64993,
	"./copy.svg": 87823,
	"./copywhite.svg": 35224,
	"./cross.svg": 77150,
	"./elk-finance.png": 66647,
	"./flag_de.svg": 10192,
	"./flag_en.svg": 49124,
	"./flag_es.svg": 95372,
	"./flag_fr.svg": 60839,
	"./flag_ja.svg": 44850,
	"./flag_ko.svg": 85160,
	"./flag_ru.svg": 76176,
	"./flag_zh.svg": 85896,
	"./flp_icon.svg": 64319,
	"./footer-bull-only-logo.png": 15693,
	"./fxdx-logo-bull.png": 31695,
	"./fxdx-logo-final-white-small.png": 76556,
	"./fxdx-logo-final-white.png": 23840,
	"./fxdx-logo-final.png": 11397,
	"./fxdx-logo-glow.png": 96730,
	"./fxdx-logo-with-name.svg": 90717,
	"./fxdx_logo.svg": 35246,
	"./fxdxblackfinal.svg": 42598,
	"./graphite-01.png": 26020,
	"./hyper-bg.svg": 55778,
	"./ic-communityproject.svg": 78046,
	"./ic_arbitrum_16.svg": 41898,
	"./ic_arbitrum_24.svg": 79762,
	"./ic_arbitrum_96.svg": 99060,
	"./ic_arbitrum_hover_16.svg": 48133,
	"./ic_arrowleft16.svg": 71774,
	"./ic_arrowright16.svg": 95143,
	"./ic_avalanche_16.svg": 5412,
	"./ic_avalanche_24.svg": 84820,
	"./ic_avalanche_96.svg": 90742,
	"./ic_avax_24.svg": 90750,
	"./ic_avax_30.svg": 10506,
	"./ic_avax_40.svg": 22807,
	"./ic_banxa.svg": 75136,
	"./ic_base_16.svg": 35051,
	"./ic_base_24.svg": 51390,
	"./ic_base_96.svg": 27318,
	"./ic_binance_logo.svg": 85685,
	"./ic_bsc.svg": 47680,
	"./ic_bsc_96.svg": 65163,
	"./ic_btc.b_24.svg": 68279,
	"./ic_btc.b_40.svg": 91709,
	"./ic_btc_24.svg": 49351,
	"./ic_btc_40.svg": 80543,
	"./ic_busd_24.svg": 99823,
	"./ic_busd_40.svg": 8650,
	"./ic_buy_flp.svg": 75021,
	"./ic_cash.png": 33795,
	"./ic_cash.svg": 42531,
	"./ic_cbeth_24.svg": 12506,
	"./ic_cbeth_40.svg": 70538,
	"./ic_checked.svg": 21019,
	"./ic_coingecko_16.svg": 85613,
	"./ic_coingecko_hover_16.svg": 29277,
	"./ic_coinmarketcap_16.svg": 62702,
	"./ic_convert_down.svg": 34935,
	"./ic_copy_16.svg": 15603,
	"./ic_cost.svg": 97906,
	"./ic_dai_24.svg": 86592,
	"./ic_dai_40.svg": 9641,
	"./ic_discord.svg": 21797,
	"./ic_eth_24.svg": 47639,
	"./ic_eth_40.svg": 78432,
	"./ic_ethereum_16.svg": 42840,
	"./ic_ethereum_24.svg": 20123,
	"./ic_ethereum_96.svg": 11595,
	"./ic_feth_24.svg": 20945,
	"./ic_feth_40.svg": 82569,
	"./ic_flp_24.svg": 45676,
	"./ic_flp_40.svg": 14137,
	"./ic_flp_custom.svg": 64370,
	"./ic_frax_24.svg": 5790,
	"./ic_frax_40.svg": 90630,
	"./ic_fxdx.svg": 26145,
	"./ic_fxdx_24.svg": 83274,
	"./ic_fxdx_30.svg": 74058,
	"./ic_fxdx_40.svg": 56058,
	"./ic_fxdx_64.svg": 82751,
	"./ic_fxdx_arbitrum.svg": 92592,
	"./ic_fxdx_avax.svg": 54369,
	"./ic_fxdx_big.svg": 59019,
	"./ic_fxdx_custom.svg": 42910,
	"./ic_fxdx_footer.svg": 29110,
	"./ic_github.svg": 27467,
	"./ic_glmr_24.svg": 23299,
	"./ic_glmr_40.svg": 18031,
	"./ic_hop.svg": 86934,
	"./ic_info.svg": 38628,
	"./ic_language24.svg": 71085,
	"./ic_link_24.svg": 88956,
	"./ic_link_40.svg": 79529,
	"./ic_liquidity.svg": 76738,
	"./ic_medium.svg": 57488,
	"./ic_menu_dots.svg": 64337,
	"./ic_metamask_16.svg": 31356,
	"./ic_metamask_hover_16.svg": 68177,
	"./ic_mim_24.svg": 95643,
	"./ic_mim_40.svg": 17928,
	"./ic_moonbeam_16.svg": 45570,
	"./ic_moonbeam_200.svg": 17568,
	"./ic_moonbeam_24.svg": 39246,
	"./ic_multiswap.svg": 49215,
	"./ic_new_link_16.svg": 60613,
	"./ic_olympus.svg": 39219,
	"./ic_olympus_arbitrum.svg": 17682,
	"./ic_op_24.svg": 55605,
	"./ic_op_40.svg": 70711,
	"./ic_optimism_16.svg": 7975,
	"./ic_optimism_24.svg": 57275,
	"./ic_optimism_96.svg": 13955,
	"./ic_selector_dropdowns.svg": 31370,
	"./ic_settings_16.svg": 88317,
	"./ic_settings_24.svg": 94240,
	"./ic_sign in_16.svg": 37516,
	"./ic_sign_out_16.svg": 98741,
	"./ic_simpleswaps.svg": 50240,
	"./ic_stats.svg": 98865,
	"./ic_stats_big.svg": 39236,
	"./ic_synapse.svg": 56993,
	"./ic_telegram.svg": 50933,
	"./ic_tether_24.svg": 8466,
	"./ic_tokens.svg": 12870,
	"./ic_totaluser.svg": 26141,
	"./ic_trading.svg": 35095,
	"./ic_transfer_avax.svg": 54478,
	"./ic_twitter.svg": 16396,
	"./ic_uni_24.svg": 61691,
	"./ic_uni_40.svg": 79812,
	"./ic_usdbc_24.svg": 12051,
	"./ic_usdbc_40.svg": 9208,
	"./ic_usdc(m)_24.svg": 87769,
	"./ic_usdc(m)_40.svg": 94530,
	"./ic_usdc(w)_24.svg": 62693,
	"./ic_usdc(w)_40.svg": 6224,
	"./ic_usdc.e_24.svg": 40890,
	"./ic_usdc.e_40.svg": 14206,
	"./ic_usdc_24.svg": 8038,
	"./ic_usdc_40.svg": 1924,
	"./ic_usdt_24.svg": 17039,
	"./ic_usdt_40.svg": 59757,
	"./ic_wallet_24.svg": 75395,
	"./ic_wavax_24.svg": 62690,
	"./ic_wavax_40.svg": 29994,
	"./ic_wbtc(m)_24.svg": 10723,
	"./ic_wbtc(m)_40.svg": 13901,
	"./ic_wbtc(w)_24.svg": 7463,
	"./ic_wbtc(w)_40.svg": 39683,
	"./ic_wbtc_24.svg": 93205,
	"./ic_wbtc_40.svg": 50195,
	"./ic_weth_24.svg": 9151,
	"./ic_weth_40.svg": 8521,
	"./ic_wglmr_24.svg": 99617,
	"./ic_wglmr_40.svg": 51419,
	"./ic_wld_24.svg": 16931,
	"./ic_wld_40.svg": 29874,
	"./lg_arbitrum.svg": 96276,
	"./lifi.svg": 76969,
	"./logo.png": 81053,
	"./logo_FXDX.svg": 34670,
	"./logo_FXDX_small.svg": 10012,
	"./long.svg": 54905,
	"./metamask-text.svg": 78232,
	"./metamask.png": 46521,
	"./next.png": 1828,
	"./next.svg": 72330,
	"./o3-swap.png": 32215,
	"./page-not-found.svg": 39014,
	"./position-share-bg.png": 59430,
	"./prev.svg": 60081,
	"./rank1.svg": 40788,
	"./rank2.svg": 39182,
	"./rank3.svg": 75507,
	"./router-protocol.png": 39254,
	"./search.svg": 8452,
	"./shareCard.png": 39815,
	"./short.svg": 28800,
	"./speaker.svg": 83876,
	"./swap.svg": 1630,
	"./synapse-protocol.png": 83446,
	"./trading.jpg": 30393,
	"./umbria-network.png": 49605,
	"./via.jpeg": 78869,
	"./wallet-connect-text.svg": 51812,
	"./wallet.svg": 90387,
	"./walletconnect-circle-blue.svg": 68891,
	"./wave-01.png": 49338,
	"./wave-02.png": 55046,
	"./wormhole.jpeg": 66859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;